import PropTypes from 'prop-types'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Trans, useTranslation } from 'react-i18next'

import API from '../../../../api/api'
import { useSnackbar } from '../../../../helpers/hooks/useSnackbar'
import { selectBuildingById } from '../../../../reducers/buildingSelectorReducer'

const ApartmentsConnectionModal = ({ buildingId, onClose, onBack, onConnected }) => {
  const { t } = useTranslation(['organisation', 'common'])
  const [isLoading, setIsLoading] = useState(false)
  const { displaySnackbar } = useSnackbar()
  const selectedBuilding = useSelector((state) => selectBuildingById(state)(buildingId))

  const handleConnect = async () => {
    try {
      setIsLoading(true)

      await API.connectApartmentsProvider(buildingId)

      await API.saveApartmentsLocation(
        buildingId,
        selectedBuilding.apartmentsId,
        selectedBuilding.apartmentsName,
      )

      displaySnackbar(
        t('organisation:reputationManagement.apartmentsConnectionModal.toasts.connected'),
        false,
      )
      onConnected()
      onClose()
    } catch (error) {
      console.error(error)
      displaySnackbar(
        t('organisation:reputationManagement.apartmentsConnectionModal.errors.connectFailed'),
        true,
      )
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      {selectedBuilding.apartmentsId ? (
        <div className="reputation-management-page__settings--info">
          <Trans
            i18nKey="organisation:reputationManagement.apartmentsConnectionModal.foundBuilding"
            values={{ name: selectedBuilding.apartmentsName }}
            components={[
              <a
                key="link"
                href="https://www.apartments.com"
                target="_blank"
                rel="noopener noreferrer"
              />,
              <br key="br" />,
            ]}
          />
        </div>
      ) : (
        <div className="reputation-management-page__settings--info">
          <Trans
            i18nKey="organisation:reputationManagement.apartmentsConnectionModal.connectInstructions"
            components={[
              <a
                key="link"
                href="https://www.apartments.com"
                target="_blank"
                rel="noopener noreferrer"
              />,
            ]}
          />
        </div>
      )}

      <div className="reputation-management-page__settings--buttons">
        <button className="button button-gray" onClick={onBack} disabled={isLoading}>
          {t('common:actions.back')}
        </button>
        <button
          className={`button button-black ${isLoading ? 'is-loading' : ''}`}
          onClick={handleConnect}
          disabled={!selectedBuilding.apartmentsId || isLoading}
        >
          {t('organisation:reputationManagement.apartmentsConnectionModal.connect')}
        </button>
      </div>
    </>
  )
}

ApartmentsConnectionModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  buildingId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
}

export default ApartmentsConnectionModal
